(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("TronLinkExtensionCore", [], factory);
	else if(typeof exports === 'object')
		exports["TronLinkExtensionCore"] = factory();
	else
		root["TronLinkExtensionCore"] = factory();
})(this, () => {
return 